import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from './Navigation';
import config from '../config';

const SubscriptionSuccess = () => {
  const [status, setStatus] = useState('checking');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const params = new URLSearchParams(location.search);
  const sessionId = params.get('session_id');

  useEffect(() => {
    const verifySubscription = async () => {
      if (!sessionId) {
        setError('No session ID provided');
        setStatus('error');
        return;
      }

      try {
        setStatus('verifying');
        const response = await fetch(`${config.apiUrl}/api/subscription/success?session_id=${sessionId}`);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Failed to verify subscription');
        }

        // Store token and login if provided
        if (data.token) {
          localStorage.setItem('token', data.token);
          login(data.token);
        }

        setStatus('success');
        // Redirect to complete signup with email and session_id
        navigate(`/complete-signup?email=${encodeURIComponent(data.user.email)}&session_id=${sessionId}`);
      } catch (err) {
        console.error('Subscription verification error:', err);
        setError(err.message || 'Failed to verify subscription');
        setStatus('error');
      }
    };

    verifySubscription();
  }, [sessionId, navigate, login]);

  return (
    <div className="page-container">
      <Navigation />
      <main className="main-content">
        <div className="container">
          <h1 className="page-title heading-2">Completing Your Subscription</h1>
          {status === 'checking' && (
            <div className="info-message">
              <div className="loading-spinner"></div>
              <p>Preparing to verify your subscription...</p>
            </div>
          )}
          {status === 'verifying' && (
            <div className="info-message">
              <p>Verifying your subscription...</p>
            </div>
          )}
          {status === 'success' && (
            <div className="success-message">
              <p>Subscription verified! Setting up your account...</p>
            </div>
          )}
          {status === 'error' && (
            <div className="error-message">
              <p>{error}</p>
              <button 
                className="button button-primary"
                onClick={() => navigate('/pricing')}
              >
                Back to Pricing
              </button>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default SubscriptionSuccess;
